import moment from "moment";
import html2pdf from "html2pdf.js";
import { Link } from "react-router-dom";
import Modal from '@mui/material/Modal';
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";

import 'react-circular-progressbar/dist/styles.css';
import { URL } from "../../../env";
import { toggleModal } from "../../../reducers/modalReducer";
import { getRequest, postRequest, showMessage } from '../../../config';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';


export default function FitReport({ user, company, module, tab, setTab, setIsBackFitReport, fitInvestorFirms, getFitInvestorFirms, investorId, linearProgress, setIsShowFitReport, sortSections }) {

	const dispatch = useDispatch();
	const modal = useSelector(state => state.modal);
	const getHeight = child => child.offsetHeight + parseFloat(getComputedStyle(child).marginTop) + parseFloat(getComputedStyle(child).marginBottom);

	let [isReload, setIsReload] = useState(false);
	let [leadStatus, setLeadStatus] = useState('');
	let [fitMetrics, setFitMetrics] = useState({});
	let [investorFirm, setInvestorFirm] = useState({});
	let [isBlurContact, setIsBlurContact] = useState(true);
	let [isEditDeatils, setIsEditDeatils] = useState(false);
	let [sectionTab, setSectionTab] = useState(['Fit Metrics', 'About the Investor', 'About the Company', 'Foundational Diligence Reports', 'Value Diligence Reports', 'Detailed Answers']);
	// OPTIMIZATION: Lazy load directors when not available (excluded in lightweight mode)
	let [directors, setDirectors] = useState(company?.['directors'] || []);
	// OPTIMIZATION: Lazy load research aid reports when not available (excluded in lightweight mode)
	let [researchAidReports, setResearchAidReports] = useState(company?.['researchAidReports'] || []);

	// Fetch directors if not available (excluded in lightweight mode)
	useEffect(() => {
		const fetchDirectors = async () => {
			if (company?.['directorsCount'] !== undefined && !company?.['directors']) {
				try {
					const response = await getRequest(`/company/${company._id}/directors`);
					if (response['code'] === 200 && response['body']) {
						setDirectors(response['body']['directors'] || []);
					}
				} catch (e) {
					console.error('Failed to fetch directors:', e);
				}
			} else if (company?.['directors']) {
				setDirectors(company['directors']);
			}
		};
		fetchDirectors();
	}, [company?._id, company?.['directors'], company?.['directorsCount']]);

	// Fetch research aid reports if not embedded on the company object (not always included)
	useEffect(() => {
		const fetchReports = async () => {
			if (company?.['researchAidReports']) {
				setResearchAidReports(company['researchAidReports']);
				return;
			}
			try {
				const response = await getRequest(`/company/${company._id}/reports`);
				if (response['code'] === 200 && response['body']?.['reports']) {
					setResearchAidReports(response['body']['reports']['researchAidReports'] || []);
				}
			} catch (e) {
				console.error('Failed to fetch reports:', e);
			}
		};
		if (company?._id) fetchReports();
	}, [company?._id, company?.['researchAidReports'], company?.['reportsCount']]);


	const handleScroll = (tab) => {
		const element = document.querySelector(`[data-target="${tab}"]`); // Target element
		if (element) {
			const yOffset = -100; // Adjust this value as needed
			const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
			window.scrollTo({ top: y, behavior: "smooth" });
		}
	};

	useEffect(() => {
		if (localStorage.getItem('scrollToFoundational')) {
			setTimeout(() => document.getElementById('Foundational Diligence Reports').scrollIntoView({ behavior: 'smooth' }), 100);
			localStorage.removeItem('scrollToFoundational');
		}
		if (localStorage.getItem('scrollToValue')) {
			setTimeout(() => document.getElementById('Value Diligence Reports').scrollIntoView({ behavior: 'smooth' }), 100);
			localStorage.removeItem('scrollToValue');
		}

		let scrollTo = '';
		let clientId = (location.href.split('#')[0]).split('/')[4];
		if (location.hash.includes('#fit-report')) investorId = (location.href.split('#').slice(-1)[0]).split(':').slice(-1)[0];
		if (investorId) getFitReport(investorId, scrollTo);
		if (clientId && investorId) getFitMetrics(clientId, investorId, scrollTo);
	}, []);

	useEffect(() => {
		document.getElementById("pdfContent").classList.add("a4-pdf", "p3rem");
		let wrapper = document.getElementById("pdf");
		wrapper.innerHTML = "";
		let children = Array.from(document.getElementById("pdfContent").children);
		let i = 0;
		let _pageNumber = 1
		let page = document.createElement("div");
		page.classList.add("a4-pdf", "oyh", "bg1", "bsbb", "oh", "pr", "p1-5rem", "shadow", "new-report");
		wrapper.appendChild(page);  // Append the first page directly
		let usedPageHeight = 96;  // Initial height used on the page
		let pageHeight = getHeight(page);
		let footerHeight = 8;

		// Create watermark
		let watermark = document.createElement("img");
		watermark.classList.add("op20", "pa");
		watermark.style.transform = "translate(-50%, -50%) rotate(30deg)";
		watermark.style.top = "50%";
		watermark.style.left = "50%";
		watermark.style.width = "297mm";
		page.appendChild(watermark);

		let section = document.querySelector('#pdfContent .section-break');
		while (children.length && i < 250) {
			// Process children for table and other content
			for (let child of children) {
				i++;
				// Create footerLogo
				let footer = document.createElement("div");
				footer.classList.add("tac", "fw600", "df", "jcsb", "aife", "pa", "c36", "b10", "l0", "pdfFooterCustom");
				let footerLogo = document.createElement("img");
				footerLogo.src = "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/miniicon-1735284051094.png";
				footerLogo.alt = "miniicon";
				footerLogo.classList.add("h40px", "w40px", "tal");

				// Create trademark
				let trademark = document.createElement("p");
				trademark.innerText = `© Diligentsia Limited ${new Date().getFullYear()}`;
				trademark.classList.add("tac", "c37", "fs12px", "fw400");

				// Create pageNumber
				let pageNumber = document.createElement("h3");
				pageNumber.innerText = "Page " + _pageNumber
				pageNumber.classList.add("fw600", "c36", "fs14px");

				// Append footerLogo and trademark to footer
				footer.appendChild(footerLogo);
				footer.appendChild(trademark);
				footer.appendChild(pageNumber);

				let childHeight = getHeight(child);
				if ((usedPageHeight + childHeight + footerHeight > pageHeight) || (child?.className == section?.className)) {
					page.classList.add("df", "fdc");
					if (i > 1) {
						_pageNumber++;
						page = createNewPage(wrapper);
						page.appendChild(footer);
					}
					usedPageHeight = 96;
				}
				page.appendChild(child.cloneNode(true));
				usedPageHeight += childHeight;
			}

			// Remove processed children
			children.splice(0, children.length);
		}

		// Clean up after processing
		wrapper.classList.remove("op0", "pen");
		document.getElementById("pdfContent").classList.remove("a4", "p3rem");

		let contentBtn = document.querySelectorAll("#pdf button");
		for (let j = 0; j < contentBtn.length; j++) {
			if (contentBtn[j]['id'] == 'bio') contentBtn[j].addEventListener('click', () => dispatch(toggleModal({ open: 'investorBio' })));
			if (contentBtn[j]['id'] == 'edit-details') contentBtn[j].addEventListener('click', () => { setIsEditDeatils(false), dispatch(toggleModal({ open: 'editDetails' })) });
			if (contentBtn[j]['id'] == 'view-contact') contentBtn[j].addEventListener('click', () => handleAcceptReject('Accepted'));
			if (contentBtn[j]['id'] == 'contact-details') contentBtn[j].addEventListener('click', () => dispatch(toggleModal({ open: 'companyContactDetails' })));
			if (contentBtn[j]['id'] == 'manage-file') contentBtn[j].addEventListener('click', () => dispatch(toggleModal({ open: 'manageFiles' })));
			if (contentBtn[j]['id'] == 'foundational-report') contentBtn[j].addEventListener('click', handleFoundationalReport);
			if (contentBtn[j]['id'] == 'director-foundational-report') contentBtn[j].addEventListener('click', handleDirectorFoundationalReport);
			if (contentBtn[j]['id'] == 'value-report') contentBtn[j].addEventListener('click', handleValueReport);
			if (contentBtn[j]['id'] == 'readmore-investor-description') contentBtn[j].addEventListener('click', () => dispatch(toggleModal({ open: 'readMoreInvestorDescription' })));
			if (contentBtn[j]['id'] == 'readmore-criteria') contentBtn[j].addEventListener('click', () => dispatch(toggleModal({ open: 'readMoreCriteria' })));
			if (contentBtn[j]['id'] == 'readmore-company-description') contentBtn[j].addEventListener('click', () => dispatch(toggleModal({ open: 'readMoreCompanyDescription' })));

			if (contentBtn[j]['id'] == 'copy') contentBtn[j].addEventListener('click', (e) => {
				navigator.clipboard.writeText(e.target.id);
				showMessage('Text Copied!');
			});
		}
	});

	function createNewPage(wrapper) {
		let newPage = document.createElement("div");
		newPage.classList.add("a4-pdf", "oyh", "bg1", "bsbb", "oh", "pr", "p1-5rem", "shadow", "new-report");

		let header = document.createElement("img");
		header.classList.add("db", "ma", "h1rem");
		titleHeading(newPage);

		wrapper.appendChild(newPage);
		return newPage;
	};

	useEffect(() => {
		if (isReload) window.location.reload();
	}, [location.href]);

	useEffect(() => {
		if (Object.keys(fitMetrics).length > 0) {
			if (fitMetrics['leadStatus'] == 'Accepted') setIsBlurContact(false);
			else setIsBlurContact(true);
		}

	}, [fitMetrics]);

	const handleFoundationalReport = (e) => {
		if (e.target.id !== 'foundational-report') {
			setIsBackFitReport(true);
			localStorage.setItem('scrollToFoundational', true);
			setTab(e.target.id);
		}
	};

	const handleDirectorFoundationalReport = (e) => {
		if (e.target.id) {
			setIsBackFitReport(true);
			localStorage.setItem('scrollToFoundational', true);
			dispatch(toggleModal({ open: 'showDirectors' }));
		}
	}

	const handleValueReport = (e) => {
		if (e.target.id !== 'value-report') {
			setIsBackFitReport(true);
			localStorage.setItem('scrollToValue', true);
			setTab(e.target.id);
		}
	}

	const handleInvestorLeads = async () => {
		if (fitInvestorFirms.length == 0) await getFitInvestorFirms();
		setIsReload(true);
	};

	const getFitReport = async (investorId, scrollTo) => {
		let response = await getRequest(`/company/getInvestorFirm/${investorId}`);
		if (response['code'] == 200) {
			await setInvestorFirm(response['body']);
			if (scrollTo !== '') document.getElementById(scrollTo).scrollIntoView();
		}
	};

	const getFitMetrics = async (clientId, investorId, scrollTo) => {
		let response = await postRequest(`/company/getFitMetrics`, { clientId, investorId });
		console.log("***********response::", response);
		if (response['code'] == 200) {
			await setFitMetrics(response['body']);
			if (scrollTo !== '') document.getElementById(scrollTo).scrollIntoView();
		}
	};

	const handleAcceptReject = (status) => {
		setLeadStatus(status);
		dispatch(toggleModal({ open: 'clientAcceptReject' }));
	};

	const updateLeadStatus = async (status) => {
		let clientId = (location.href.split('#')[0]).split('/')[4];
		// let investorId = (location.href.split('#').slice(-1)[0]).split(':').slice(-1)[0];
		const data = {
			status,
			client: company['creatorId'],
			clientId,
			investor: user,
			investorId,
		};

		if (clientId && investorId && investorFirm && company && company?.['creatorId']) {
			let res = await postRequest(`/company/updateLeadStatus`, data);
			if (res['code'] == 200) {
				if (status == 'Accepted') setIsBlurContact(false);
				else setIsBlurContact(true);
				if (clientId && investorId) getFitMetrics(clientId, investorId, '');
				showMessage(res['message']);
				dispatch(toggleModal({ open: '' }));
			}
		}
	};

	const titleHeading = (page) => {
		let title = document.createElement("span");
		title.classList.add("db", "w100", "fw600", "fs1-25rem", "tal", "c15");
		title.innerText = 'Fit Report';

		let subTitle = document.createElement("span");
		subTitle.classList.add("db", "w100", "fw300", "fs1rem", "tal", "c15");
		subTitle.innerText = user['role'] == "Investor" ? investorFirm['cName'] : company['cName'];

		page.appendChild(title);
		page.appendChild(subTitle);
	};

	const convertImageToBase64 = async (imgUrl) => {
		try {
			const proxyUrl = `${URL}/api/company/pdf-proxy?url=${encodeURIComponent(imgUrl)}`;
			const response = await fetch(proxyUrl);
			const blob = await response.blob();
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onloadend = () => resolve(reader.result);
				reader.onerror = reject;
				reader.readAsDataURL(blob);
			});
		} catch (error) {
			console.error('Error converting image to base64:', error);
			return imgUrl;
		}
	};

	const convertAllImagesToBase64 = async (element) => {
		const images = element.querySelectorAll('img');
		const imagePromises = [];
		for (const img of images) {
			const src = img.src;
			if (src && (src.includes('s3') || src.includes('amazonaws') || src.includes('cloudfront'))) {
				imagePromises.push(convertImageToBase64(src).then(base64 => {
					img.setAttribute('data-original-src', src);
					img.src = base64;
				}).catch(() => { }));
			}
		}
		await Promise.all(imagePromises);
	};

	const restoreOriginalImages = (element) => {
		const images = element.querySelectorAll('img[data-original-src]');
		for (const img of images) {
			img.src = img.getAttribute('data-original-src');
			img.removeAttribute('data-original-src');
		}
	};

	const downloadPDF = async () => {
		try {
			const wrapper = document.getElementById("pdf");
			document.querySelectorAll(".oscy").forEach(el => el.classList.remove("h60vh"));
			document.querySelectorAll(".tableRow").forEach(el => el.classList.remove("mah40vh"));
			document.querySelectorAll(".tableRow").forEach(el => el.classList.add("mah100vh"));
			wrapper.classList.remove("gg2rem");
			for (const page of wrapper.children)
				page.classList.remove("shadow");
			for (const hideEl of wrapper.querySelectorAll(".hideOnDownload"))
				hideEl.classList.add("op0");

			// Convert S3 images to base64 before generating PDF
			await convertAllImagesToBase64(wrapper);
			const filename = 'Fit-Report';
			const opt = {
				filename,
				jsPDF: { unit: 'mm', format: 'a4', orientation: 'p' },
				html2canvas: { useCORS: true, allowTaint: true, logging: false, scale: 2 }
			};
			await html2pdf().set(opt).from(wrapper).save();

			// Restore original image URLs after PDF generation
			restoreOriginalImages(wrapper);

			wrapper.classList.add("gg2rem");
			for (const page of wrapper.children)
				page.classList.add("shadow");
			for (const hideEl of wrapper.querySelectorAll(".hideOnDownload"))
				hideEl.classList.remove("op0");
			document.querySelectorAll(".oscy").forEach(el => el.classList.add("h60vh"));
			document.querySelectorAll(".tableRow").forEach(el => el.classList.add("mah40vh"));
			document.querySelectorAll(".tableRow").forEach(el => el.classList.remove("mah100vh"));
		} catch (e) { console.error(e); }
	};

	const getOverviewContent = () => {
		return <div className="minh100vh">
			<div className="dg gg1rem minh100vh-report">
				<div className="report-start">
					<div className="df jcsb">
						<div class='tal c15'>
							<h2 className="fs1-25rem fw600 ttu usn">Fit Report</h2>
							<p className="ass fs1-25rem mb1-5rem">{company['cName']}</p>

							<p className="ass fs1rem">Company Reg: <b>{company?.['ukRegNo']}</b></p>
							<p className="ass fs1rem">Subscription: <b>{company?.['subscription']}</b></p>
							<p className="ass fs1rem">Objective: <b>Investment</b></p>
						</div>
						<div class='tar c15'>
							<img className="bo5 bw2 bss mb1rem w60px h60px br100" src={(user['role'] == "Investor" ? company?.['logo'] : investorFirm?.['logo']) || require(`../../../../images/profile-photo.jpeg`)} alt="image" />

							<p className="ass fs1rem">Generated By: <b>Temp</b></p>
							<p className="ass fs1rem">Report Date : <b>{moment(Date.now()).format('ll')}</b></p>
							{module?.['sections'] && <p className="c12 ass fs0-75rem">Last Module Update: {moment(module?.['sections']?.[0]?.['updatedAt']).format('ll')}</p>}
						</div>
					</div>
					<div className='df jcc bo5 bw1px bss br10px p2rem my1rem'>
						<div className='df fdc aic w30 progress-box'>
							<div className={`progress-bar workflow-report-progress ${(module?.stats?.completionPercent || 0) > 67 ? 'workflow-progress-green' : (module?.stats?.completionPercent || 0) > 33 ? 'workflow-progress-yellow' : '  workflow-progress-grey'}`}
								style={{ width: 60, height: 60, borderRadius: '50%', margin: 0, border: '2px solid #F1F1F1' }}>
								<CircularProgressbar
									text={(module?.stats?.completionPercent || 0) + "%"}
									styles={buildStyles({
										strokeWidth: '0',
										textSize: '25px',
										trailColor: '#FBFBFB',
										stroke: 'transparent',
										strokeLinecap: 'butt',
										backgroundColor: '#FBFBFB',
										pathTransitionDuration: 0.5,
										dominantBaseline: 'ideographic',
									})}
								/>
							</div>
							<span style={{ marginBottom: '0', fontSize: '14px' }} className=" c12">Investor<span class='c4'>Match</span> One<span class='c4'>Form</span> <br /> Completeness</span>
						</div>
						<div class='w40 df jcc'>
							<p class='fs1-25rem fw500'>Overall Result</p>
						</div>
						<div className='df fdc aic w30 progress-box'>
							<div className={`progress-bar workflow-report-progress ${fitMetrics['fitScorePercentage'] > 85 ? 'workflow-progress-green' : fitMetrics['fitScorePercentage'] > 70 ? 'workflow-progress-orange' : '  workflow-progress-pink'}`}
								style={{ width: 60, height: 60, borderRadius: '50%', margin: 0, border: '2px solid #F1F1F1' }}>
								<CircularProgressbar
									text={(fitMetrics['fitScorePercentage'] || 0) + "%"}
									styles={buildStyles({
										strokeWidth: '0',
										textSize: '25px',
										trailColor: '#FBFBFB',
										stroke: 'transparent',
										strokeLinecap: 'butt',
										backgroundColor: '#FBFBFB',
										pathTransitionDuration: 0.5,
										dominantBaseline: 'ideographic',
									})}
								/>
							</div>
							<span style={{ marginBottom: '0', fontSize: '14px' }} className="c12">Fit Score</span>
						</div>
					</div>
				</div>
			</div>
			<hr class='c5' />
			<div id="section-btn" className="btn-group fit-btn-group mt1rem">
				{sectionTab.map((tab, idx) => {
					return <button id={`content-btn-${idx}`} class='w100 df cp bg5 mb0-5rem'>
						<i className="fa fa-angle-right mr1rem" style={{ fontSize: '24px' }} aria-hidden="true" />
						<div className='w100 df fs1rem fw500 c15 mb0-5rem' style={{ padding: '5px' }}>
							<span data-scroll-to={tab} class='w20 fs1rem fw600 tal ml2rem'>0{idx + 1}</span>
							<span data-scroll-to={tab} class='w80 fs1rem fw300 tal'>{tab}</span>
						</div>
					</button>

				})}
			</div>
			<p class='bo5 bw1px bss br10px p1rem c14 mt0-5rem' style={{ fontSize: '10px' }}>
				<span class='c15 fw500'>Disclaimer - General Use & Responsibility:</span><br />
				This report has been generated using the Diligentsia platform and is provided for general information purposes only. The content is based entirely on information, responses, and documentation submitted by the company, and Diligentsia Limited does not verify, audit, or validate the accuracy, completeness, or reliability of any such input.
				All outputs, including assessments, scores, and matches, are derived from algorithmic logic applied to self-declared data and do not constitute investment advice, endorsement, recommendation, or assurance of quality or suitability. Diligentsia Limited is not authorised or regulated by the Financial Conduct Authority and does not carry out any regulated activities as defined in the Financial Services and Markets Act 2000.
				The company remains solely responsible for the substance and accuracy of all information provided, and any party using this report — including prospective investors — must undertake their own due diligence and seek independent professional advice before making decisions based on its contents. Diligentsia accepts no liability for any loss or consequence arising from reliance on this report or any of its outputs.
			</p>
			<p class='bo5 bw1px bss br10px p1rem c14 mt0-5rem' style={{ fontSize: '10px' }}>
				<span class='c15 fw500'>Disclaimer – Platform Processes and Algorithms:</span><br />
				The outputs contained in this report are generated through automated processes and algorithms provided by the Diligentsia platform. While these tools are designed to assist with structuring and presenting company information, Diligentsia Limited makes no representation or warranty as to the accuracy, completeness, or reliability of any outcome produced by such processes.
				The platform does not conduct contextual analysis, independent verification, or human review of user inputs, and no algorithmic result should be relied upon as a definitive statement of fact. Diligentsia accepts no responsibility for any inaccuracies, omissions, or misclassifications that may arise as a result of the operation of its tools, and disclaims all liability for any decisions made or actions taken in reliance on the outputs.
			</p>
		</div>
	};

	const handleCopyClipboard = async (text) => {
		await navigator.clipboard.writeText(text);
		showMessage('Text Copied!');
	};

	// Get Fit Metrics Content
	const getFitMetricsContent = () => {
		return <>
			<div className="section-break"></div>
			<div class='mt3rem'>
				<p className="w100 fs1rem fw600 c15 mb0-5rem ml1rem">Fit Metrics</p>
				<div className="w100 df jcc bo5 bw1px bss br10px p1rem" id="Fit Metrics">
					<div class='w80 df jcc fdc aic'>
						<img className="bo5 bw2 bss mb0-5rem w50px h50px br100" src={investorFirm?.['logo'] || require(`../../../../images/profile-photo.jpeg`)} alt="image" />
						<p className="c15 fs1rem fw500">{investorFirm?.['cName']}</p>
					</div>
					<div className='w20 df jcc fdc aic'>
						<div className={`progress-bar workflow-report-progress ${fitMetrics['fitScorePercentage'] > 85 ? 'workflow-progress-green' : fitMetrics['fitScorePercentage'] > 70 ? 'workflow-progress-orange' : '  workflow-progress-pink'}`}
							style={{ width: 50, height: 50, borderRadius: '50%', margin: 0, border: '2px solid #F1F1F1' }}>
							<CircularProgressbar
								text={(fitMetrics['fitScorePercentage'] || 0) + "%"}
								styles={buildStyles({
									strokeWidth: '0',
									textSize: '20px',
									trailColor: '#FBFBFB',
									stroke: 'transparent',
									strokeLinecap: 'butt',
									backgroundColor: '#FBFBFB',
									pathTransitionDuration: 0.5,
									dominantBaseline: 'ideographic',
								})}
							/>
						</div>
						<span style={{ marginBottom: '0', fontSize: '14px' }} className="c12">Fit Score</span>
					</div>
				</div>
				<div class='df jcc mt3rem'>
					<table className="table table-striped">
						<thead>
							<tr>
								<th class='fs0-75rem fsi fw400 c0' style={{ background: '#000f66c7', color: '#fff' }}>#</th>
								<th class='fs0-75rem fsi fw400 c0' style={{ background: '#000f66c7', color: '#fff' }}>Preferred Investment Criteria</th>
								<th class='fs0-75rem fsi fw400 c0' style={{ background: '#000f66c7', color: '#fff' }}>Company Matching Information</th>
								<th class='fs0-75rem fsi fw400 c0' style={{ background: '#000f66c7', color: '#fff' }}>Fit</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<th class='fs0-75rem c15 fsi' scope="row"><p>Preferred Sectors:</p></th>
								<td class='fs0-75rem c15 fsi'>{fitMetrics?.['preferredSectors']?.['firmValue'] ? fitMetrics?.['preferredSectors']?.['firmValue'] : '-'}</td>
								<td class='fs0-75rem c15 fsi'>{fitMetrics?.['preferredSectors']?.['selectedValue'] ? fitMetrics?.['preferredSectors']?.['selectedValue'] : '-'}</td>
								<td class='fs0-75rem c15 fsi'><i className={`fa fa-circle ${(fitMetrics?.['preferredSectors']?.['percentage']) > 70 ? 'green' : (fitMetrics?.['preferredSectors']?.['percentage']) > 30 ? 'orange' : 'red'}`}></i></td>
							</tr>
							<tr>
								<th class='fs0-75rem c15 fsi bg5' scope="row"><p>Preferred Investment Stage:</p></th>
								<td class='fs0-75rem c15 fsi bg5'>{fitMetrics?.['stageFocus']?.['firmValue'] ? fitMetrics?.['stageFocus']?.['firmValue'] : '-'}</td>
								<td class='fs0-75rem c15 fsi bg5'>{fitMetrics?.['stageFocus']?.['selectedValue'] ? fitMetrics?.['stageFocus']?.['selectedValue'] : '-'}</td>
								<td class='fs0-75rem c15 fsi bg5'><i className={`fa fa-circle ${(fitMetrics?.['stageFocus']?.['percentage']) > 70 ? 'green' : (fitMetrics?.['stageFocus']?.['percentage']) > 30 ? 'orange' : 'red'}`}></i></td>
							</tr>
							<tr>
								<th class='fs0-75rem c15 fsi' scope="row"><p>Investment Sweet Spot:</p></th>
								<td class='fs0-75rem c15 fsi'>{fitMetrics?.['sweetSpot']?.['firmValue'] ? fitMetrics?.['sweetSpot']?.['firmValue'] : '-'}</td>
								<td class='fs0-75rem c15 fsi'>{fitMetrics?.['sweetSpot']?.['selectedValue'] ? fitMetrics?.['sweetSpot']?.['selectedValue'] : '-'}</td>
								<td class='fs0-75rem c15 fsi'><i className={`fa fa-circle ${(fitMetrics?.['sweetSpot']?.['percentage']) > 70 ? 'green' : (fitMetrics?.['sweetSpot']?.['percentage']) > 30 ? 'orange' : 'red'}`}></i></td>
							</tr>
							<tr>
								<th class='fs0-75rem c15 fsi bg5' scope="row"><p>Minimum Annual Revenues:</p></th>
								<td class='fs0-75rem c15 fsi bg5'>{fitMetrics?.['annualRevenues']?.['firmValue'] ? fitMetrics?.['annualRevenues']?.['firmValue'] : '-'}</td>
								<td class='fs0-75rem c15 fsi bg5'>{fitMetrics?.['annualRevenues']?.['selectedValue'] ? fitMetrics?.['annualRevenues']?.['selectedValue'] : '-'}</td>
								<td class='fs0-75rem c15 fsi bg5'><i className={`fa fa-circle ${(fitMetrics?.['annualRevenues']?.['percentage']) > 70 ? 'green' : (fitMetrics?.['annualRevenues']?.['percentage']) > 30 ? 'orange' : 'red'}`}></i></td>
							</tr>
							<tr>
								<th class='fs0-75rem c15 fsi' scope="row"><p>Minimum Annual Profits:</p></th>
								<td class='fs0-75rem c15 fsi'>{fitMetrics?.['annualProfits']?.['firmValue'] ? fitMetrics?.['annualProfits']?.['firmValue'] : '-'}</td>
								<td class='fs0-75rem c15 fsi'>{fitMetrics?.['annualProfits']?.['selectedValue'] ? fitMetrics?.['annualProfits']?.['selectedValue'] : '-'}</td>
								<td class='fs0-75rem c15 fsi'><i className={`fa fa-circle ${(fitMetrics?.['annualProfits']?.['percentage']) > 70 ? 'green' : (fitMetrics?.['annualProfits']?.['percentage']) > 30 ? 'orange' : 'red'}`}></i></td>
							</tr>
							<tr>
								<th class='fs0-75rem c15 fsi' scope="row"><p>Preferred Regions:</p></th>
								<td class='fs0-75rem c15 fsi'>{fitMetrics?.['regionFocus']?.['firmValue'] ? fitMetrics?.['regionFocus']?.['firmValue'] : '-'}</td>
								<td class='fs0-75rem c15 fsi'>{fitMetrics?.['regionFocus']?.['selectedValue'] ? fitMetrics?.['regionFocus']?.['selectedValue'] : '-'}</td>
								<td class='fs0-75rem c15 fsi'><i className={`fa fa-circle ${(fitMetrics?.['regionFocus']?.['percentage']) > 70 ? 'green' : (fitMetrics?.['regionFocus']?.['percentage']) > 30 ? 'orange' : 'red'}`}></i></td>
							</tr>
						</tbody>
					</table>
				</div>
				<div className="df jcc w100 mt2rem">
					<button id='manage-file' className="w200px cp df jcc aic tac mxa br25px py0-5rem bg3 bg4-hover c1 fs0-75rem">View Pitch Deck</button>
				</div>
			</div>
		</>
	};

	// Get About Investor Content
	const getAboutInvestorContent = () => {
		return <>
			<div className="section-break"></div>
			<div className="mt1rem" id="About the Investor">
				<p className="w100 fs1rem fw600 c15 mb0-5rem ml1rem">About the Investor</p>
				<div className="w100 df jcc bo5 bw1px bss br10px p1rem" id="Fit Metrics">
					<div className='w20 df jcc aic'>
						{investorFirm?.['source']?.['isBVCA'] && <img className="w50px ml0-5rem" src={require(`../../../../images/bvca-logo.png`)} alt="image" />}
						{investorFirm?.['source']?.['isCrunchBase'] && <img className="w50px ml0-5rem" src={require(`../../../../images/crunchbase-logo.png`)} alt="image" />}
						{investorFirm?.['source']?.['isSeedLegals'] && <img className="w50px ml0-5rem" src={require(`../../../../images/swwdleagals.png`)} alt="image" />}
					</div>
					<div class='w60 df jcc fdc aic'>
						<img className="bo5 bw2 bss mb0-5rem w50px h50px br100" src={investorFirm?.['logo'] || require(`../../../../images/profile-photo.jpeg`)} alt="image" />
						<a href={investorFirm['cWebsite']} target="_blank" className="cp c15 c3-hover fs1rem fw500">{investorFirm?.['cName']}</a>
					</div>
					<div className='w20 df jcc fdc aic'>
						<div className={`progress-bar workflow-report-progress ${investorFirm?.['promptScore'] > 67 ? 'workflow-progress-green' : investorFirm?.['promptScore'] > 33 ? 'workflow-progress-yellow' : '  workflow-progress-grey'}`}
							style={{ width: 50, height: 50, borderRadius: '50%', margin: 0, border: '2px solid #F1F1F1' }}>
							<CircularProgressbar
								text={(investorFirm?.['promptScore'] || 0) + "%"}
								styles={buildStyles({
									strokeWidth: '0',
									textSize: '20px',
									trailColor: '#FBFBFB',
									stroke: 'transparent',
									strokeLinecap: 'butt',
									backgroundColor: '#FBFBFB',
									pathTransitionDuration: 0.5,
									dominantBaseline: 'ideographic',
								})}
							/>
						</div>
						<span style={{ marginBottom: '0', fontSize: '14px' }} className="c12">Prompt Score</span>
					</div>
				</div>
			</div>
			<div className="df jcsb mt1rem">
				<div class='df fdc aic'>
					<p className="w100 tal mb0-5rem c15 fs0-75rem">Full Company Name: <b>{investorFirm['cName'] ? investorFirm['cName'] : '-'}</b></p>
					<p className="w100 tal mb0-5rem c15 fs0-75rem">Website: {investorFirm['cWebsite']
						? <a className="tdu wordbreak" href={investorFirm['cWebsite']} target="_blank">{investorFirm['cWebsite']}</a>
						: '-'}
					</p>
					<p className="w100 tal mb0-5rem c15 fs0-75rem">Business Location: <b>{investorFirm?.['cCountry'] ? investorFirm?.['cCountry'] : '-'}</b></p>
					<p className="w100 tal mb0-5rem c15 fs0-75rem">No. of Investments made: <b>{fitMetrics?.['noOfInvestments']?.['firmValue'] ? fitMetrics?.['noOfInvestments']?.['firmValue'] : '-'}</b></p>
				</div>
				<div class='df fdc aic'>
					<p className="w100 tal mb0-5rem c15 fs0-75rem">Address: <b>{investorFirm['cAddress'] ? investorFirm['cAddress'] : '-'}</b></p>
					<p className="w100 tal mb0-5rem c15 fs0-75rem">Tel: <b>{investorFirm['cPhone'] ? investorFirm['cPhone'] : '-'}</b></p>
					<p className="w100 tal mb0-5rem c15 fs0-75rem">Funds for Investment: <b>{fitMetrics?.['fundsAvailable']?.['firmValue'] ? fitMetrics?.['fundsAvailable']?.['firmValue'] : '-'}</b></p>
					<p className="w100 tal mb0-5rem c15 fs0-75rem">Date of last Investment: <b>{fitMetrics?.['lastInvestmentDate']?.['firmValue'] ? fitMetrics?.['lastInvestmentDate']?.['firmValue'] : '-'}</b></p>
				</div>
			</div>
			<p class='fs0-75rem c15 mt1rem'>
				<b>Description</b><br />
				{(investorFirm?.['companyDescription'] && investorFirm['companyDescription'].length > 600)
					? <>{investorFirm['companyDescription'].substring(0, 1000)}... <button id="readmore-investor-description" className="cp tdu fs0-75rem fw600 bg1">read more</button></>
					: investorFirm['companyDescription']
				}
			</p>
			<p class='fs0-75rem c15 my1rem'>
				<b>Investment Criteria</b><br />
				{(investorFirm?.['investmentCriteria'] && investorFirm['investmentCriteria'].length > 600)
					? <>{investorFirm['investmentCriteria'].substring(0, 1000)}... <button id="readmore-criteria" className="cp tdu fs0-75rem fw600 bg1">read more</button></>
					: investorFirm['investmentCriteria']
				}
			</p>
			{/* {user['role'] == "Investor" &&
				<div className="df jcfe">
					<button id='edit-details' className="bo5 bw2 bss bg3 bg4-hover c1 td250 br5px py0-5rem px1rem fw600 usn cp ttu bsbb tac fs0-75rem">Edit Details?</button>
				</div>
			} */}
			<div className="w100 df my1rem">
				<div className={`w50 bg5 p0-5rem bo5 bw1px bss df fww aic br8px`}>
					<div className={`user-area w20`}>
						<div className="user-img">
							<img className=" h4rem w4rem br100" src={investorFirm?.['contact']?.['profile'] || investorFirm?.['contact']?.['profilePicture'] || require(`../../../../images/profile-photo.jpeg`)} alt="image" />
						</div>
					</div>
					<div className={`progress-box w50`}>
						<div className="text-box tal">
							<h4 className="fs0-75rem df">
								<p>{investorFirm?.['contact']?.['name'] ? investorFirm?.['contact']?.['name'] : investorFirm?.['contact']?.['firstName'] + ' ' + investorFirm?.['contact']?.['lastName'] || 'Name: -'}</p>
								{investorFirm?.['contact']?.['linkedIn'] &&
									<a href={investorFirm?.['contact']?.['linkedIn']} target="_blank" className="icon w10px ml0-5rem bg5 cp">
										<i><svg version="1.1" className="f3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 310 310">
											<g>
												<path d="M72.16,99.73H9.927c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5H72.16c2.762,0,5-2.238,5-5V104.73
													C77.16,101.969,74.922,99.73,72.16,99.73z"/>
												<path d="M41.066,0.341C18.422,0.341,0,18.743,0,41.362C0,63.991,18.422,82.4,41.066,82.4
													c22.626,0,41.033-18.41,41.033-41.038C82.1,18.743,63.692,0.341,41.066,0.341z"/>
												<path d="M230.454,94.761c-24.995,0-43.472,10.745-54.679,22.954V104.73c0-2.761-2.238-5-5-5h-59.599
													c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5h62.097c2.762,0,5-2.238,5-5v-98.918c0-33.333,9.054-46.319,32.29-46.319
													c25.306,0,27.317,20.818,27.317,48.034v97.204c0,2.762,2.238,5,5,5H305c2.762,0,5-2.238,5-5V194.995
													C310,145.43,300.549,94.761,230.454,94.761z"/>
											</g>
										</svg></i>
									</a>
								}
							</h4>
							<p className="fs0-75rem c6">{investorFirm?.['contact']?.['designation'] || 'Designation'}</p>
							<p className="fs0-75rem c6">Phone: {investorFirm?.['contact']?.['phone']
								? <>{investorFirm?.['contact']?.['phone']} <button className="cp bg5" id='copy'><i id={investorFirm?.['contact']?.['phone']} className="fa fa-clipboard c4" style={{ fontSize: '12px' }}></i></button></>
								: '-'}</p>
						</div>
					</div>
					<div className="df jcc button-list w30">
						<button id='bio' className="bg3 bg4-hover c1 br20px py0-5rem px2rem cp df jcc aic fw500 fs0-75rem">Bio</button>
					</div>
				</div>
			</div>
		</>
	};

	// Get About Company Content
	const getAboutCompanyContent = () => {
		return <>
			<div className="section-break"></div>
			<div className="mt1rem" id="About the Company">
				<p className="w100 fs1rem fw600 c15 mb0-5rem ml1rem">About the Company</p>
			</div>
			<div class='w100 df jcc'>
				<div class='w20 df jcc'>
					<img className="bo5 bw1px bss br10px p0-5rem w60px h60px mb1rem" src={company?.['logo'] || require(`../../../../images/profile-photo.jpeg`)} alt="image" />
				</div>
				<div class='w80 df jcsb'>
					<div class='w40 df fdc aic'>
						<p class='fs0-75rem w100 c15'>Company Name: <b>{company['cName'] ? company['cName'] : '-'}</b></p>
						<p class='fs0-75rem w100 c15'>Website: <b>{company['cWebsite'] ? <a className="tdu wordbreak" href={company['cWebsite']} target="_blank">{company['cWebsite']}</a> : '-'}</b></p>
						<p class='fs0-75rem w100 c15'>Sectors: <b>{fitMetrics?.['preferredSectors']?.['selectedValue'] ? fitMetrics?.['preferredSectors']?.['selectedValue'] : '-'}</b></p>
					</div>
					<div class='w40 df fdc aic'>
						<p class='fs0-75rem w100 c15'>Address: <b>{company['cAddress'] ? company['cAddress'] : '-'}</b></p>
						<p class='fs0-75rem w100 c15'>Tel: <b>{company['cPhone'] ? company['cPhone'] : '-'}</b></p>
						<p class='fs0-75rem w100 c15'>Full Time Employees: <b>{fitMetrics?.['fullTimeEmployees'] ? fitMetrics?.['fullTimeEmployees'] : '-'}</b></p>
					</div>
				</div>
			</div>
			<p class='fs0-75rem c15 mt1rem'>
				<b>Description</b><br />
				{(company?.['companyDescription'] && company['companyDescription'].length > 600)
					? <>{company['companyDescription'].substring(0, 1000)}... <button id="readmore-company-description" className="cp tdu fs0-75rem fw600 bg1">read more</button></>
					: company['companyDescription']
				}
			</p>
			<div className="report-start mt1-5rem">
				<div className={`dg gtcr-audit fs0-75rem c1 gtcr-audit-fit-report-about br10px`} style={{ background: '#000f66c7' }}>
					<h3 className="fs0-75rem fw400 tac">#</h3>
					<h3 className="fs0-75rem fw400 tac">Actual Previous Year</h3>
					<h3 className="fs0-75rem fw400 tac">Expected Current Year</h3>
					<h3 className="fs0-75rem fw400 tac">Forcast Next Year</h3>
				</div>
				<div className={`dg tableRow fs0-75rem gtcr-audit-fit-report-about`}>
					<div className={`df jcc c15 fsi fw600 pt0-25rem`}>Revenues</div>
					<div className={`df jcc c15 fsi pt0-25rem`}>{fitMetrics?.['previousRevenues'] ? fitMetrics?.['previousRevenues'] : '-'}</div>
					<div className={`df jcc c15 fsi pt0-25rem`}>{fitMetrics?.['annualRevenues']?.['selectedValue'] ? fitMetrics?.['annualRevenues']?.['selectedValue'] : '-'}</div>
					<div className={`df jcc c15 fsi pt0-25rem`}>{fitMetrics?.['nextRevenues'] ? fitMetrics?.['nextRevenues'] : '-'}</div>
				</div>
				<div className={`dg tableRow fs0-75rem gtcr-audit-fit-report-about`}>
					<div className={`df jcc c15 fsi fw600 pt0-25rem`}>Profits/(Loss)</div>
					<div className={`df jcc c15 fsi pt0-25rem`}>{fitMetrics?.['previousProfits'] ? fitMetrics?.['previousProfits'] : '-'}</div>
					<div className={`df jcc c15 fsi pt0-25rem`}>{fitMetrics?.['annualProfits']?.['selectedValue'] ? fitMetrics?.['annualProfits']?.['selectedValue'] : '-'}</div>
					<div className={`df jcc c15 fsi pt0-25rem`}>{fitMetrics?.['nextProfits'] ? fitMetrics?.['nextProfits'] : '-'}</div>
				</div>
			</div>
			<div className="w50 bg1 p1rem bo5 bw1px bss df fww aic mt1rem br8px">
				<div className={`user-area tac w100`}>
					<div className="user-img">
						<img className="h4rem w4rem br100" src={company?.['creatorId']?.['profile'] || require(`../../../../images/profile-photo.jpeg`)} alt="image" />
					</div>
					<div className="df fdc aic tac">
						<h4 className="fs0-75rem df jcc">
							<span>{company?.['creatorId']?.['firstName']} {company?.['creatorId']?.['lastName']}</span>
							{company?.['creatorId']?.['linkedIn'] &&
								<a href={company?.['creatorId']?.['linkedIn']} target="_blank" className="icon w10px ml0-5rem bg5 cp">
									<i><svg version="1.1" className="f3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 310 310">
										<g>
											<path d="M72.16,99.73H9.927c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5H72.16c2.762,0,5-2.238,5-5V104.73
													C77.16,101.969,74.922,99.73,72.16,99.73z"/>
											<path d="M41.066,0.341C18.422,0.341,0,18.743,0,41.362C0,63.991,18.422,82.4,41.066,82.4
													c22.626,0,41.033-18.41,41.033-41.038C82.1,18.743,63.692,0.341,41.066,0.341z"/>
											<path d="M230.454,94.761c-24.995,0-43.472,10.745-54.679,22.954V104.73c0-2.761-2.238-5-5-5h-59.599
													c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5h62.097c2.762,0,5-2.238,5-5v-98.918c0-33.333,9.054-46.319,32.29-46.319
													c25.306,0,27.317,20.818,27.317,48.034v97.204c0,2.762,2.238,5,5,5H305c2.762,0,5-2.238,5-5V194.995
													C310,145.43,300.549,94.761,230.454,94.761z"/>
										</g>
									</svg></i>
								</a>
							}
						</h4>
						<button id='contact-details' className="df jcc bg3 bg4-hover c1 br20px fw600 w70 py0-5rem fs0-75rem">Contact Details</button>
					</div>
				</div>
				{/* {(user['role'] == 'Investor' && isBlurContact) && (
					<button id='view-contact' className="pa t0 r0 mr1rem mt1rem view-btn-fit" style={{ backgroundColor: "transparent" }}>
						<i
							data-tooltip='<p className="fs0-75rem">Note: By clicking this button, lead requested by this client will be accepted.</p>'
							class='fa fa-eye c8 cp'
							style={{ fontSize: '20px' }}
						/>
						<span className="fs0-75rem">Contact Details</span>
					</button>
				)} */}
			</div>
		</>
	};

	// Get Foundational Diligence Reports
	const getFoundationalDiligenceReports = () => {
		return <>
			<div className="section-break"></div>
			<div className="mt2rem" id="Foundational Diligence Reports">
				<p className="w100 fs1rem fw600 c15 mb0-5rem ml1rem">Foundational Diligence Reports</p>
				{/* Data Repository */}
				{foundationalDiligenceCard({ title: 'Data Repository', completionPercent: (company?.['modules']?.['repository']?.['stats']?.['completionPercent'] || 0), valueReportId: 'repository-report' })}
				{/* Business Audit */}
				{foundationalDiligenceCard({ title: 'Business Audit', completionPercent: (company?.['modules']?.[`business-audit-${company['testType']}`]?.['stats']?.['completionPercent'] || 0), riskPercent: (company?.['modules']?.[`business-audit-${company['testType']}`]?.['stats']?.['riskPercent'] || 0), valueReportId: `business-audit-${company['testType']}-report` })}
				{/* Directors Questionnaire */}
				{foundationalDiligenceCard({ title: 'Directors Questionnaire', completionPercent: (company?.['directorsStats']?.['completionPercent'] || 0), riskPercent: (company?.['directorsStats']?.['riskPercent'] || 0) })}
				{/* Warranty Disclosure Schedule */}
				{foundationalDiligenceCard({ title: 'Warranty Disclosure Schedule', completionPercent: (company?.['modules']?.[`warranty-disclosure`]?.['stats']?.['completionPercent'] || 0), riskPercent: (company?.['modules']?.[`warranty-disclosure`]?.['stats']?.['riskPercent'] || 0), valueReportId: `warranty-disclosure-report` })}
				<div class='w100 df bo5 bw1px br10px bss px1rem py2rem my0-5rem'>
					<p class='w30 df jcc tac fs1rem fw600 c15'>Unaudited Certification</p>
					<div class='w70 df jcc'>
						<button>
							<div className="bottom-certification w100 my0-5rem df jcfs fww">
								<img className="w90" src={require(`../../../../images/advisor-dashboard/banner-certificate-bottom.png`)} alt="" />
								{linearProgress &&
									<div className="progress-dashboard-horizantal w90" role="progressbar" id="progressBar">
										<div className="progress-bar progress-bar-striped progress-bar-animated" id="innerBar" style={{ width: `${linearProgress}%` }}></div>
									</div>
								}
							</div>
						</button>
					</div>
				</div>
			</div>
		</>
	};

	const foundationalDiligenceCard = ({ title, completionPercent, riskPercent, valueReportId }) => {
		return <>
			<div class='w100 df bo5 bw1px br10px bss px1rem py2rem my0-5rem'>
				<p class='w30 df jcc tac fs1rem fw600 c15'>{title}</p>
				<div class='w40 df jcc'>
					<div class='df fdc aic mr1rem'>
						<p class={`fs1rem fw600 ${completionPercent > 67 ? 'green' : completionPercent > 33 ? 'orange' : completionPercent > 0 ? 'red' : 'c12'}`}>{completionPercent}%</p>
						<p class='fs0-75rem c12'>Completeness</p>
					</div>
					{title !== 'Data Repository' &&
						<div class='df fdc aic'>
							<p class={`fs1rem fw600 ${riskPercent > 67 ? 'red' : riskPercent > 33 ? 'orange' : riskPercent > 0 ? 'red' : 'c12'}`}>{riskPercent}%</p>
							<p class='fs0-75rem c12'>Risk</p>
						</div>
					}
				</div>
				<div class='w30 df jcc'>
					{completionPercent > 0
						? title == 'Directors Questionnaire'
							? <button id='director-foundational-report' class='cp w70 fs0-75rem fw500 c1 bg3 br20px py0-5rem tac' style={{ maxHeight: '35px' }}>View Report</button>
							: <button id='foundational-report' class='cp w70 fs0-75rem fw500 c1 bg3 br20px py0-5rem tac' style={{ maxHeight: '35px' }}><Link to={`/company/${company['_id']}#${valueReportId}`} id={valueReportId}>View Report</Link></button>
						: <button data-tooltip='Insufficient information provided to run report' class='cna w70 fs0-75rem fw500 py0-5rem c1 bg12 br20px' style={{ maxHeight: '35px' }}>View Report</button>
					}
				</div>
			</div>
		</>
	};

	// Get Value Diligence Reports
	const getValueDiligenceReports = () => {
		return <>
			<div className="section-break"></div>
			<div className="mt2rem" id="Value Diligence Reports">
				<p className="w100 fs1rem fw600 c15 mb0-5rem ml1rem">Value Diligence Reports</p>
				{researchAidReports && researchAidReports.length > 0
					? researchAidReports.map(report => {
						return <>{valueDiligenceCard(report)}</>
					})
					: <div className="w100 df fdc aic jcc bo5 bw1px br10px bss px1rem py3rem mt4rem my0-5rem">
						<p className="fs1rem fw600 c15 tac mb0-5rem">No ResearchAid reports generated yet</p>
						<p className="fs0-875rem fw400 c12 tac">Generate ResearchAid reports to view your Value Diligence Reports here.</p>
					</div>
				}
			</div>
		</>
	};

	const valueDiligenceCard = (report) => {
		return <>
			<div class='w100 df bo5 bw1px br10px bss px1rem py2rem my0-5rem'>
				<p class='w30 df jcc tac fs1rem fw600 c15'>{report['name']}</p>
				<div class='w40 df jcc'>
					<div class='df fdc aic mr1rem'>
						<p class={`fs1rem fw600 ${report['score'] >= 4 ? 'c34' : report['score'] >= 2 ? 'c39' : report['score'] > 0 ? 'c4' : 'c12'}`}>
							{report?.['score'] ? Number.parseFloat(report['score']).toFixed(1) : '0.0'}%
						</p>
						<p class='fs0-75rem c12'>Report Score/5</p>
					</div>
				</div>
				<div class='w30 df jcc'>
					{report?.['htmlReport']
						? <button id='value-report' class='cp w70 fs0-75rem fw500 c1 bg3 br20px py0-5rem tac' style={{ maxHeight: '35px' }}><Link to={`/company/${company['_id']}#${report['_id']}?${report['reportType']}-researchaid`} id={`${report['reportType']}-researchaid`}>View Report</Link></button>
						: <button data-tooltip='Insufficient information provided to run report' class='cna w70 fs0-75rem fw500 c1 bg12 br20px' style={{ maxHeight: '35px' }}>View Report</button>
					}
				</div>
			</div>
		</>
	};

	// Get Detailed Answers
	const getDetailedAnswers = () => {
		let sections = [];
		if (module?.sections[0]?.subFolders && Object.values(module?.sections[0]?.subFolders).length > 0) sections = Object.values(module.sections[0].subFolders).filter(s => !s.isHidden);
		sections = sections.slice().sort(sortSections);

		return <>
			{sections.length > 0 && sections.map((section, sectionIdx) => {
				let questions;
				questions = section?.questions || [];

				let completionPercent, riskPercent;
				if (section?.stats?.completionPercent) completionPercent = section.stats.completionPercent;
				if (section?.stats?.riskPercent) riskPercent = section.stats.riskPercent;

				questions = sortQuestionsByQNo(questions);

				return <>
					<div className="section-break"></div>
					<div className="mt2rem" id="Detailed Answers">
						<p className="w100 fs1rem fw600 c15 ml1rem">One<span class='c4'>Form</span> Detailed Answer</p>
						<div className="mt1rem">
							<div className={`w100 df p1rem fs0-75rem c1 br10px`} style={{ background: '#000f66c7' }}>
								<p className="w50 fs0-75rem fw600 tal ml2rem">Question</p>
								<p className="w50 fs0-75rem fw600 tal ml2rem">Answer</p>
							</div>
							<div>
								<p class='fs1rem fw600 c15 my1rem ml1rem'>Section-{sectionIdx + 1}: {section['name']}<span className='mx1rem'>|</span><span className={`fw400 ${completionPercent < 34 ? "c9" : completionPercent < 67 ? 'c8' : 'c7'}`}>{completionPercent}% Completed</span></p>
								{questions && questions.length > 0 && questions.map((ques, quesIdx) => {
									return <div className={`w100 df p0-5rem br10px ${quesIdx % 2 == 0 ? 'bg5' : 'bg1'}`}>
										<p className="w50 c14 fs0-75rem fw600 tal ml2rem">{ques['qDescription']}</p>
										<p className="w50 c14 fs0-75rem fw600 tal ml2rem">
											{ques?.['answer']?.['dropdown'] || ques?.['answer']?.['comment'] || ques?.['answer']?.['radioOption']}<br />
											{ques?.['answer']?.['files'] && ques['answer']['files'].length > 0 && ques['answer']['files'].map(file => {
												return <a target='_blank' href={file['location']} className="fs0-75rem c15 tdu cp mr0-5rem">{file['originalname']}</a>
											})}
										</p>
									</div>
								})}
							</div>

						</div>
					</div>
				</>
			})}
		</>
	};

	const sortQuestionsByQNo = (questions) => {
		if (questions && questions.length > 0) {
			return questions.slice().sort((a, b) => {
				const aParts = a['qNo'].match(/\d+/g).map(Number);
				const bParts = b['qNo'].match(/\d+/g).map(Number);
				for (let i = 0; i < Math.max(aParts.length, bParts.length); i++)
					if ((aParts[i] || 0) !== (bParts[i] || 0)) return (aParts[i] || 0) - (bParts[i] || 0);
				return 0;
			});
		}
		return questions || [];
	};

	const showPopupPercent = (value, type) => {
		let color;
		if (type == 'Risk') color = value > 67 ? 'red' : value > 33 ? 'yellow' : 'green';
		else if (type == 'Completeness') color = value > 67 ? 'green' : value > 33 ? 'yellow' : 'red';
		return <span className={`${color}`}>{value || 0}% <span className='c6'>{type}</span></span>
	};

	const handleClosePopup = async () => {
		await window.scrollTo(0, 0);
		setTimeout(() => dispatch(toggleModal({ open: '' })), 200);
	};

	return <>
		<div className="td250 container bg1 py2rem bo5 bw2 bss w100 df">
			<div className="w100 mr1rem dg bg5 py2rem">
				<div className="df aic jcc w100 mb2rem">
					<button onClick={() => downloadPDF()} className="cp tac ml1rem bg3 bg4-hover fs0-75rem c1 br20px px2rem py0-5rem fw600">
						<svg className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path className="fa-primary" d="M424.1 320.1l-88 88C334.4 411.5 328.5 416 320 416s-14.4-4.467-16.97-7.031l-88-88c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L296 334.1V184C296 170.8 306.8 160 320 160s24 10.75 24 24v150.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0S434.3 311.6 424.1 320.1z" /><path className="fa-secondary" d="M537.6 226.6C541.7 215.9 544 204.2 544 192c0-53-43-96-96-96c-19.69 0-38.09 6-53.31 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.703 .1094 5.445 .2031 8.133C40.2 219.8 0 273.2 0 336C0 415.5 64.5 480 144 480H512c70.69 0 128-57.3 128-128C640 290.1 596 238.4 537.6 226.6zM424.1 320.1l-88 88C334.4 411.5 328.5 416 320 416s-14.4-4.467-16.97-7.031l-88-88c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L296 334.1V184C296 170.8 306.8 160 320 160s24 10.75 24 24v150.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0S434.3 311.6 424.1 320.1z" /></svg>
						Download PDF
					</button>
					{user['role'] == 'User' && (
						<button onClick={() => { setIsShowFitReport(false); handleInvestorLeads() }} className="cp tac ml1rem bg3 bg4-hover fs0-75rem c1 br20px px2rem py0-5rem fw600">
							Back to Investor Leads
						</button>
					)}
					{localStorage.getItem('isQualifiedLeads') && user['role'] == 'Investor' &&
						<Link to="/investor-dashboard#index?QualifiedLeads" onClick={() => localStorage.removeItem("isQualifiedLeads")} className="cp tac ml1rem bg4 bg3-hover fs0-75rem c1 br20px px2rem py0-5rem fw600">
							<svg width="16" height="16" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.79039 11.7808L2.97655 7.99985L6.79039 4.21887C7.09858 3.91299 7.06263 3.4485 6.70945 3.18134C6.35626 2.91443 5.82021 2.94581 5.51145 3.25144L1.20972 7.51624C0.930093 7.7932 0.930093 8.20671 1.20972 8.48368L5.5115 12.7485C5.67959 12.9147 5.91479 13 6.15137 13C6.34949 13 6.54841 12.9402 6.70945 12.8184C7.06268 12.5512 7.09887 12.0867 6.79039 11.7808Z" fill="white" stroke="white" stroke-width="0.5"></path><path d="M14.1607 7.27344H2.20665C1.79909 7.27344 1.46875 7.60374 1.46875 8.01133C1.46875 8.4189 1.79909 8.74923 2.20665 8.74923H14.1607C16.3038 8.74923 18.0472 10.4926 18.0472 12.6355C18.0472 14.7784 16.3038 16.5218 14.1607 16.5218H3.19053C2.78297 16.5218 2.45264 16.8521 2.45264 17.2597C2.45264 17.6673 2.78297 17.9976 3.19053 17.9976H14.1607C17.1172 17.9976 19.523 15.592 19.523 12.6355C19.523 9.67899 17.1175 7.27344 14.1607 7.27344Z" fill="white" stroke="white" stroke-width="0.5"></path></svg>
							<span className='ml0-5rem'>Back to Investor Match</span>
						</Link>
					}
					{localStorage.getItem('isDiligencePack') && user['role'] == 'Investor' && (
						<Link to='#diligence-pack' onClick={() => setTab('diligence-pack')} className="cp tac ml1rem bg3 bg4-hover fs0-75rem c1 br20px px2rem py0-5rem fw600">
							Back to Diligence Pack
						</Link>
					)}
				</div>
				{company && <>
					<table id="pdf" className="op0 pen ma td250 dg gg2rem"></table>
					{user['role'] == 'User' &&
						<div className="df jcc mt1rem">
							<button onClick={() => { setIsShowFitReport(false); handleInvestorLeads() }} className="cp tac ml1rem bg3 bg4-hover fs0-75rem c1 br20px px2rem py0-5rem fw600">
								Back to Investor Leads
							</button>
						</div>
					}

					{localStorage.getItem('isDiligencePack') && user['role'] == 'Investor' && (
						<div className="df jcc mt1rem">
							<Link to='#diligence-pack' onClick={() => setTab('diligence-pack')} className="cp tac ml1rem bg3 bg4-hover fs0-75rem c1 br20px px2rem py0-5rem fw600">
								Back to Diligence Pack
							</Link>
						</div>

					)}
					<table id="pdfContent" className="bsbb w0 h0 oh op0 pen db">
						{getOverviewContent()}
						{getFitMetricsContent()}
						{getAboutInvestorContent()}
						{getAboutCompanyContent()}
						{getFoundationalDiligenceReports()}
						{getValueDiligenceReports()}
						{getDetailedAnswers()}
					</table>
				</>}
			</div>
		</div>

		{/* Investor Bio */}
		<Modal open={modal['open'] == 'investorBio'} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
			<div className="mah100 oya bg1 bo5 bw2 bss w100 px3rem py1rem bsbb df fdc m1rem maw600px br5px pr">
				<button data-scroll-to='About the Investor' className="close-popup" onClick={() => handleClosePopup()}>
					<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
						<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
					</svg>
				</button>
				<div className="pr modal-bio investor-leads-tooltip">
					<p className="tac c15 lh2 fs1-75rem fw600 mb2rem">Investor Bio</p>
					<div className="user-area">
						<span className="tooltip-area cp" style={{ top: '35px', right: '20px' }}>
							<i className="icon">
								<img className="h2rem" src={require(`../../../../images/info-icon.svg`)} alt="" />
								<div className="overlay-box" style={{ left: '-400px' }}>
									<p>Please note that if you wish to contact the investor directly, then they will not received the additional validation of the Diligentsia Diligence Report nor the fit report, and it will be treated by the investor as an unsolicited approach, which historically result in less attention/success.</p>
								</div>
							</i>
						</span>
						<div className="user-img">
							<img className="h4rem w4rem br100" src={investorFirm?.['contact']?.['profile'] || investorFirm?.['contact']?.['profilePicture'] || require(`../../../../images/profile-photo.jpeg`)} alt="image" />
						</div>
						<div className="text-box">
							<h4 className="fs0-75rem df">
								<span>{investorFirm?.['contact']?.['name'] ? investorFirm?.['contact']?.['name'] : investorFirm?.['contact']?.['firstName'] + ' ' + investorFirm?.['contact']?.['lastName'] || 'Name: -'}</span>
								{investorFirm?.['contact']?.['linkedIn'] &&
									<a href={investorFirm?.['contact']?.['linkedIn']} target="_blank" className="icon w10px ml0-5rem bg1 cp">
										<svg version="1.1" className="f3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 310 310">
											<g>
												<path d="M72.16,99.73H9.927c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5H72.16c2.762,0,5-2.238,5-5V104.73
													C77.16,101.969,74.922,99.73,72.16,99.73z"/>
												<path d="M41.066,0.341C18.422,0.341,0,18.743,0,41.362C0,63.991,18.422,82.4,41.066,82.4
													c22.626,0,41.033-18.41,41.033-41.038C82.1,18.743,63.692,0.341,41.066,0.341z"/>
												<path d="M230.454,94.761c-24.995,0-43.472,10.745-54.679,22.954V104.73c0-2.761-2.238-5-5-5h-59.599
													c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5h62.097c2.762,0,5-2.238,5-5v-98.918c0-33.333,9.054-46.319,32.29-46.319
													c25.306,0,27.317,20.818,27.317,48.034v97.204c0,2.762,2.238,5,5,5H305c2.762,0,5-2.238,5-5V194.995
													C310,145.43,300.549,94.761,230.454,94.761z"/>
											</g>
										</svg>
									</a>
								}
							</h4>
							<p className={`fs0-75rem df`}>Email: {investorFirm?.['contact']?.['email']
								? <>{investorFirm?.['contact']?.['email']} <button className="cp bg1" onClick={() => handleCopyClipboard(investorFirm?.['contact']?.['email'])}><i className="fa fa-clipboard c4" style={{ fontSize: '12px' }}></i></button></>
								: '-'}</p>
							<p className={`fs0-75rem df`}>Phone:{investorFirm?.['contact']?.['phone']
								? <>{investorFirm?.['contact']?.['phone']} <button className="cp bg1" onClick={() => handleCopyClipboard(investorFirm?.['contact']?.['phone'])}><i className="fa fa-clipboard c4" style={{ fontSize: '12px' }}></i></button></>
								: '-'}</p>
						</div>
					</div>
					<div className="description-box my1rem pr">
						<div className="df jcsb">
							<h4 className="fs1rem mb0-5rem">Bio:</h4>
							{user['role'] == "Investor" && <button onClick={() => { setIsEditDeatils(true), dispatch(toggleModal({ open: 'editDetails' })) }} className="bo5 bw2 bss bg3 bg4-hover c1 td250 br5px py0-5rem px1rem fw600 usn cp ttu bsbb tac fs0-75rem mb1rem">Edit Details?</button>}
						</div>
						<p className="fs0-75rem">{investorFirm?.['contact']?.['bio'] && investorFirm?.['contact']?.['bio'] !== 'n/a' ? investorFirm?.['contact']?.['bio'] : 'No information available from our search'}</p>
					</div>
					{/* <div className="description-box mt1rem pr">
						<h4 className="fs1rem mb1rem">About</h4>
						<p className="fs0-75rem">{investorFirm?.['contact']?.['linkedinAbout'] ? investorFirm?.['contact']?.['linkedinAbout'] : 'No information available from our search'}</p>
					</div> */}
				</div>

			</div>
		</Modal>

		{/* Investor Read More Description */}
		<Modal open={modal['open'] == 'readMoreInvestorDescription'} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
			<div className="mah100 oya bg1 bo5 bw2 bss w100 p3rem bsbb df fdc m1rem maw600px br5px pr">
				<button data-scroll-to='About the Investor' className="close-popup" onClick={() => handleClosePopup()}>
					<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
						<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
					</svg>
				</button>
				<div className="pr modal-bio">
					<p className="tac c15 lh2 fs1-5rem fw600 mb2rem">Investor Description</p>
					<div className="description-box mt1rem pr">
						<h4 className="fs1rem c15 mb1rem">Description:</h4>
						<p className="fs0-75rem c14">{investorFirm['companyDescription']}</p>
					</div>
				</div>
			</div>
		</Modal>

		{/* Investor Read More Criteria */}
		<Modal open={modal['open'] == 'readMoreCriteria'} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
			<div className="mah100 oya bg1 bo5 bw2 bss w100 p3rem bsbb df fdc m1rem maw600px br5px pr">
				<button data-scroll-to='About the Investor' className="close-popup" onClick={() => handleClosePopup()}>
					<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
						<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
					</svg>
				</button>
				<div className="pr modal-bio">
					<p className="tac c15 lh2 fs1-5rem fw600 mb2rem">Investment Criteria</p>
					<div className="description-box mt1rem pr">
						<h4 className="fs1rem c15 mb1rem">Criteria:</h4>
						<p className="fs0-75rem c14">{investorFirm['investmentCriteria']}</p>
					</div>
				</div>
			</div>
		</Modal>

		{/* Company Read More Description */}
		<Modal open={modal['open'] == 'readMoreCompanyDescription'} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
			<div className="mah100 oya bg1 bo5 bw2 bss w100 p3rem bsbb df fdc m1rem maw600px br5px pr">
				<button data-scroll-to='About the Company' className="close-popup" onClick={() => handleClosePopup()}>
					<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
						<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
					</svg>
				</button>
				<div className="pr modal-bio">
					<p className="tac c15 lh2 fs1-5rem fw600 mb2rem">Company Description</p>
					<div className="description-box mt1rem pr">
						<h4 className="fs1rem c15 mb1rem">Description:</h4>
						<p className="fs0-75rem c14">{company['companyDescription']}</p>
					</div>
				</div>
			</div>
		</Modal>

		{/* Edit Details Popup */}
		<Modal open={modal['open'] == 'editDetails'} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
			<div className="mah90 oya bg1 bo5 bw2 bss w100 px3rem py2rem bsbb df fdc m1rem maw600px br5px pr">
				<img className="h2rem pa t0 center-horizontally" src={require(`../../../../images/logo.svg`)} alt="image" style={{ top: '15px' }} />
				<button data-scroll-to='About the Investor' className="close-popup" onClick={() => handleClosePopup()}>
					<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
						<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
					</svg>
				</button>
				<h1 className="text-gradient fs2rem fw600 tac pt2rem pb1rem">Edit Details</h1>
				{isEditDeatils &&
					<p className="df tac fs1rem my1rem">We recognise that you may not be the contact person within your firm who should deal with these initial approaches, and you can nominate a colleague to be the point person in your place.  However, we wish to offer quality, not quantity of diligenced leads in both directions, and for this reason ask that you nominate a specific individual rather than a generic “enquiries @” email address.</p>
				}
				<p className="df tac fs1rem my1rem">You can edit your firm’s details or your own bio in your Investor Settings accessed via your Portfolio Pro dashboard  or booking a call with Mark Bernstein, the Diligentsia CEO </p>
				<a href="https://koalendar.com/e/meet-with-mark-bernstein" target="_blank" className="fs1rem c3 tdu mb1rem">https://koalendar.com/e/meet-with-mark-bernstein</a>
			</div>
		</Modal>

		{/* Company Contact Details */}
		<Modal open={modal['open'] == 'companyContactDetails'} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
			<div className="mah90 oya bg1 bo5 bw2 bss w100 px3rem py2rem bsbb df fdc m1rem maw600px br5px pr">
				<button data-scroll-to="About the Company" className="close-popup" onClick={() => handleClosePopup()}>
					<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
						<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
					</svg>
				</button>
				<div className="pr modal-bio">
					<h2 className="fs1-5rem fw600 mb2rem">Company Contact Details</h2>
					<div className="user-area">
						<div className="user-img">
							<img className="h4rem w4rem br100" src={company?.['creatorId']?.['profile'] || require(`../../../../images/profile-photo.jpeg`)} alt="image" />
						</div>
						<div className="text-box">
							<h4 className="fs0-75rem df">
								<span>{company?.['creatorId']?.['firstName'] ? company?.['creatorId']?.['firstName'] + ' ' + company?.['creatorId']?.['lastName'] : 'Name: -'}</span>
								{company?.['creatorId']?.['linkedIn'] &&
									<a href={company['creatorId']['linkedIn']} target="_blank" className="icon w10px ml0-5rem bg1 cp">
										<svg version="1.1" className="f3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 310 310">
											<g>
												<path d="M72.16,99.73H9.927c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5H72.16c2.762,0,5-2.238,5-5V104.73
													C77.16,101.969,74.922,99.73,72.16,99.73z"/>
												<path d="M41.066,0.341C18.422,0.341,0,18.743,0,41.362C0,63.991,18.422,82.4,41.066,82.4
													c22.626,0,41.033-18.41,41.033-41.038C82.1,18.743,63.692,0.341,41.066,0.341z"/>
												<path d="M230.454,94.761c-24.995,0-43.472,10.745-54.679,22.954V104.73c0-2.761-2.238-5-5-5h-59.599
													c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5h62.097c2.762,0,5-2.238,5-5v-98.918c0-33.333,9.054-46.319,32.29-46.319
													c25.306,0,27.317,20.818,27.317,48.034v97.204c0,2.762,2.238,5,5,5H305c2.762,0,5-2.238,5-5V194.995
													C310,145.43,300.549,94.761,230.454,94.761z"/>
											</g>
										</svg>
									</a>
								}
							</h4>
							<p className="fs0-75rem df aic">
								<span className="fw500 mr0-5rem">Email: </span>
								{company?.['creatorId']?.['email']
									? <>{company?.['creatorId']?.['email']} <button className="cp bg1" onClick={() => handleCopyClipboard(company?.['creatorId']?.['email'])}><i className="fa fa-clipboard c4" style={{ fontSize: '12px' }}></i></button></>
									: '-'}
							</p>
							<p className="fs0-75rem df aic">
								<span className="fw500 mr0-5rem">Phone: </span>
								{company?.['creatorId']?.['phone']
									? <>{company['creatorId']['phone']} <button className="cp bg1" onClick={() => handleCopyClipboard(company['creatorId']['phone'])}><i className="fa fa-clipboard c4" style={{ fontSize: '12px' }}></i></button></>
									: '-'}</p>
						</div>
					</div>
					{/* <div className="description-box mt1rem pr">
						<h4 className="fs1rem mb1rem">Description</h4>
						<p className="fs0-75rem">{company['companyDescription'] ? company['companyDescription'] : '-'}</p>
					</div> */}
				</div>

			</div>
		</Modal>

		{/* Manage Files */}
		<Modal open={modal['open'] == 'manageFiles'} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic" >
			<div className="mah90 pr oya bg1 bo5 bw2 bss w100 p3rem pt5rem bsbb df fdc m1rem maw800px br5px pr">
				<img className="h2rem pa t0 center-horizontally" src={require(`../../../../images/logo.svg`)} alt="image" style={{ top: '15px' }} />
				<button data-scroll-to="Fit Metrics" className="close-popup" onClick={() => handleClosePopup()}>
					<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
						<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
					</svg>
				</button>
				<p className="c15 fw600 tac fs1-25rem">{company.cName}</p>
				<p className="c4 fw400 tac mb1rem fs1rem">Pitch Deck</p>
				<div className='df jcc'>
				</div>
				{(fitMetrics['deckFiles'] && fitMetrics['deckFiles'].length > 0)
					? <>{fitMetrics['deckFiles'].map(file => {
						return <div className="df jcsb my1rem">
							<a target='_blank' href={file['location']} className="fs1rem c15 tdu cp">{file['originalname']}</a>
							<a href={file['location']} download>
								<svg data-tooltip={"Download"} className={`f3 h1rem cp mr1rem ${tab == 'repository' ? '' : 'mla'}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
									<path className="fa-primary" d="M105.4 246.6c-12.49-12.5-12.49-32.75 0-45.25c12.5-12.5 32.76-12.5 45.25 0L224 274.8V32c0-17.67 14.33-32 32-32c17.67 0 32 14.33 32 32v242.8l73.38-73.38c12.49-12.5 32.75-12.5 45.25 0c12.49 12.5 12.49 32.75 0 45.25l-128 128C272.4 380.9 264.2 384 256 384s-16.38-3.125-22.62-9.375L105.4 246.6z" /><path className="fa-secondary" d="M480 352h-133.5l-45.25 45.25C289.2 409.3 273.1 416 256 416s-33.16-6.656-45.25-18.75L165.5 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96C512 366.3 497.7 352 480 352zM432 456c-13.2 0-24-10.8-24-24c0-13.2 10.8-24 24-24s24 10.8 24 24C456 445.2 445.2 456 432 456z" />
								</svg>
							</a>
						</div>
					})}</>
					: <div className="dg gg1rem my2rem fs1rem">
						<span className="fs1rem fw400 gcs1 gce5-md tac">Pitch Deck haven't been added yet!</span>
					</div>
				}
			</div>
		</Modal>

		{/* Show Directors */}
		<Modal open={modal['open'] == 'showDirectors'} className="backdrop showDirectors td500 zi4 pf t0 l0 w100vw h100vh df jcc aic">
			<div className="pr maw800px inner-showDirectors pr">
				<button data-scroll-to='Diligence Reports' className="close-popup" onClick={() => handleClosePopup()}>
					<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
						<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
					</svg>
				</button>
				<div className='top-header'>
					<h1 className="text-gradient fw600 tac mb1rem">LIST OF QUESTIONNAIRES</h1>
				</div>
				<div className='table-area-showDirectors'>
					<table id="table" className="table-showDirectors">
						<thead className="ps t0">
							<tr>
								<th>Name</th>
								<th>Designation</th>
								<th>Progress</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							{directors && directors.length > 0 && <>
								{directors.map((item, idx) => (
									<tr key={idx}>
										<td className={`${item['headShot'] && 'df aic '} c6 fw500 ttc`}>
											{item['headShot'] && <img src={item['headShot']['location']} className="w2rem h2rem df jcc aic br100 bg3 c1 mr0-5rem" />}
											{item['name']}
										</td>
										<td className='c6 fw500 ttc'>{item['designation']}</td>
										<td className='p1rem c6 fw500 ttc'>({showPopupPercent(company?.['modules']?.[`directors-questionnaire_${item['_id']}`]?.['stats']?.['completionPercent'] || 0, 'Completeness')} / {showPopupPercent(company?.['modules']?.[`directors-questionnaire_${item['_id']}`]?.['stats']?.['riskPercent'] || 0, 'Risk')})</td>
										<td><button onClick={() => { localStorage.setItem('isDiligenceReport', true); setTab(`directors-questionnaire_${item['_id']}-report`) }} className="cp bg4 bg3-hover c1 tac c1 bo5 bw2 bss px1rem py0-5rem br5px fw500">Report</button></td>
									</tr>
								))}
							</>}
						</tbody>
					</table>
					{directors && directors.length == 0 &&
						<div className='tac py1rem'>
							<h2 className="text-gradient fw600">No Directors by this Company</h2>
						</div>
					}
					<div className='logo-modal'>
						<img className="h2rem" src={require(`../../../../images/logo.svg`)} alt="TODO" />
					</div>
				</div>
			</div>
		</Modal>

		{/* Accept/Reject Client */}
		<Modal open={modal['open'] == 'clientAcceptReject'} className="backdrop td500 zi4 pf t0 l0 w100 h110vh df jcc aic">
			<div className="mah90 oya bg1 bo5 bw2 bss w100 px2rem py3rem bsbb df fdc m1rem maw700px br5px pr">
				<img className="h2rem pa t0 center-horizontally" src={require(`../../../../images/logo.svg`)} alt="TODO" style={{ top: '15px' }} />
				<button data-scroll-to="actions" className="close-popup" onClick={() => handleClosePopup()}>
					<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
						<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
					</svg>
				</button>
				<h1 className="text-gradient fs2rem fw600 tac ttu mb1rem pb1rem">Access Request </h1>
				<div className="df fdc gg1rem px2rem">
					<p className="my1rem">Are you sure you want to {leadStatus.slice(0, -2).toLowerCase()} this lead request of <span className="fw500">{company['cName']}</span>?</p>
					<button data-scroll-to="actions" onClick={() => updateLeadStatus(leadStatus)} className="bo5 bw2 bss bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w100 bsbb tac df jcc aic">{leadStatus.slice(0, -2)}</button>
					<button data-scroll-to="actions" onClick={() => dispatch(toggleModal({ open: '' }))} className="bg1 c3-hover td250 fs1-25rem cp">Cancel</button>
				</div>
			</div>
		</Modal>
	</>
}
